import { render, staticRenderFns } from "./AudioPlayArea.vue?vue&type=template&id=5ec2f441&scoped=true&"
import script from "./AudioPlayArea.vue?vue&type=script&lang=js&"
export * from "./AudioPlayArea.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayArea.vue?vue&type=style&index=0&id=5ec2f441&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2f441",
  null
  
)

export default component.exports